import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.BootroomTabs = class BootroomTabs extends Snappy.BaseComponent {
    static get tagName() {
        return 'bootroom-tabs';
    }

    constructor(element) {
        super(element);
        this.lastLeft = 0;
        this.searchData = [];
    }

    setVars() {
        this.rowsPerPage = $(this.$element).data('rowsPerPage');
        this.requestUrl = $(this.$element).data('requestUrl');
        this.tabs = $(this.$element.find('.individual-tab-title'));
        this.contents = $(this.$element.find('.individual-tab-content'));
        this.activeElement = $(this.$element.find('.individual-tab-title.active'));
        this.activeContent = this.$element.find('.individual-tab-content.active');
        this.indicator = this.$element.find('.highlight');
        this.tabsWrap = this.$element.find('.tabs-bar')
        this.tabsContainer = this.$element.find('.tabs-holder');
        this.indicatorColor = this.activeElement.data('tabColor');
        this.anchor = $(this.$element.find('.bootroom-tabs-anchor'));
        this.tabsContent = $(this.$element.find('.bootroom-tabs-content'));

    }

    init() {
        this.tabs.map((i, tab) => {
            if (!$(tab).hasClass('disabled')) {
                $(tab).find('span').text(' (' + this.searchData.filter(data => $(tab).data('type').replace(/\s/g, '').split(",").includes(data.type)).length + ')');

            }
            if (!$(tab).hasClass("active")) {
                $(tab).find('h3').width($(tab).find('h3').width() + ($(tab).find('h3').width() / 15));
            } else {
                $(tab).find('h3').width($(tab).find('h3').width());
            }
            
        });

        this.contents.map((i, content) => {
            if (this.searchData.filter(data => $(content).data('type').replace(/\s/g, '').split(",").includes(data.type)).length > 0) {
                this.searchData.filter(data => $(content).data('type').replace(/\s/g, '').split(",").includes(data.type)).map((data, i) => {
                    if (i < this.rowsPerPage)
                        $(content).find('.tab-content-data').append(this.createCard(data));
                })
                if (this.searchData.filter(data => $(content).data('type').replace(/\s/g, '').split(",").includes(data.type)).length > this.rowsPerPage) {
                    $(content).append(this.createPagination(this.searchData.filter(data => $(content).data('type').replace(/\s/g, '').split(",").includes(data.type)).length))
                }
            } else {
                $(content).find('.tab-content-data').append(`<div data-name="No Results">No results</div>`);
            }
            
        })

        this.$element.find('.next-button').on('click', this.handleClickNextPage.bind(this))
        this.$element.find('.previous-button').on('click', this.handleClickPreviousPage.bind(this))
        this.activeContent.find('.pagination-button').on('click', this.handleClickPagination.bind(this));
        this.indicator.css("background-color", this.indicatorColor);
        this.activeContent.fadeIn();
        this.attachIndicator();
    }

    setEventListeners() {
        this.$element.find('.individual-tab-title').on('click', this.handleClickTab.bind(this));
        window.addEventListener("resize", this.attachIndicator.bind(this));
        window.addEventListener("DOMContentLoaded", () => {
            this.tabScroll();
            this.handleCall(this);
        })
    }

    render() {
        this.setVars();
        this.setEventListeners();
    }

    handleClickTab(e) {
        this.activeElement = $(e.currentTarget);
        
        if ((!$(e.currentTarget).hasClass('disabled')) && (!$(e.currentTarget).hasClass('active'))) {
            this.$element.find('.individual-tab-content').removeClass('active');
            this.$element.find('.individual-tab-content').hide();
            this.$element.find('.individual-tab-title').removeClass('active');

            $(e.currentTarget).addClass('active');

            if ($(window).scrollTop() > this.tabsContent.offset().top + 20) {
                window.scrollTo({ top: this.anchor.offset().top - 40, behavior: 'smooth' });
            }
            
            $('.individual-tab-content[data-name="' + e.currentTarget.dataset.name + '"]').addClass('active');
            $('.individual-tab-content[data-name="' + e.currentTarget.dataset.name + '"]').fadeIn();

            this.activeContent = $('.individual-tab-content[data-name="' + e.currentTarget.dataset.name + '"]');
            this.$element.find('.pagination-button').off();
            this.activeContent.find('.pagination-button').on('click', this.handleClickPagination.bind(this));

            this.attachIndicator();

            this.tabScroll();
        }
    }

    handleClickPagination(e) {
        let previousNumber = parseInt(this.activeContent.find('.pagination-button.active').attr('data-page-number'));
        let numberOfPages = parseInt(this.activeContent.find('.tab-pagination-buttons').data('totalPages')) - 1;
        let activeNumber = 0;
        let incrementPosition = 0;
        this.activeContent.find('.pagination-button').removeClass('active');

       
        activeNumber = parseInt($(e.currentTarget).attr('data-page-number'));

        if (numberOfPages >= 5) {
            if (activeNumber <= 0 || activeNumber >= numberOfPages) {
                incrementPosition = 0;
            }
            if (activeNumber > 1 && activeNumber < numberOfPages - 1) {
                incrementPosition = Math.abs($(e.currentTarget).data('incNumber'));
            }
            if (previousNumber <= activeNumber) {

                if (activeNumber === numberOfPages - 1) {
                    if (this.activeContent.find(`.pagination-button[data-page-number="${numberOfPages}"]`).length > 0) {
                        incrementPosition = 0;
                    } else {
                        incrementPosition = 1;
                    }
                }
                this.activeContent.find(".pagination-button").map((i, button) => {
                    if (activeNumber > 1) {
                        $(button).attr('data-page-number', parseInt($(button).attr('data-page-number')) + incrementPosition)
                        $(button).text(parseInt($(button).text()) + incrementPosition)
                    }
                    if (parseInt($(button).attr('data-page-number')) === activeNumber) {
                        $(button).addClass('active')
                    }
                })

            } else if (previousNumber > activeNumber) {
                
                if (activeNumber === 1) {
                    if (this.activeContent.find(`.pagination-button[data-page-number="0"]`).length > 0) {
                        incrementPosition = 0;
                    } else {
                        incrementPosition = 1;
                    }
                }
                this.activeContent.find(".pagination-button").map((i, button) => {
                    if (activeNumber < numberOfPages - 2) {
                        $(button).attr('data-page-number', parseInt($(button).attr('data-page-number')) - incrementPosition)
                        $(button).text(parseInt($(button).text()) - incrementPosition)
                    }
                    if (parseInt($(button).attr('data-page-number')) === activeNumber) {
                        $(button).addClass('active')
                    }
                })
            }
        } else {
            $(e.currentTarget).addClass('active');
        }

        this.handleDataPagination(activeNumber);
        e.stopPropagation()
        
    }

    handleClickNextPage() {
        let numberOfPages = parseInt(this.activeContent.find('.tab-pagination-buttons').data('totalPages')) - 1;
        let pageNumber = parseInt($(this.activeContent.find('.pagination-button.active')).attr('data-page-number'));

        $(this.activeContent.find('.pagination-button')).removeClass('active');
        if (numberOfPages >= 5) {

            if (pageNumber > 1 && pageNumber < numberOfPages - 2) {
                this.activeContent.find(".pagination-button").map((i, button) => {
                    $(button).attr('data-page-number', parseInt($(button).attr('data-page-number')) + 1)
                    $(button).text(parseInt($(button).text()) + 1)

                })
                $(this.activeContent.find('.pagination-button[data-page-number="' + (parseInt(pageNumber) + 1) + '"]')).addClass('active');
            }
        }

        $(this.activeContent.find('.pagination-button[data-page-number="' + (parseInt(pageNumber) + 1) + '"]')).addClass('active');
        pageNumber = parseInt($(this.activeContent.find('.pagination-button.active')).attr('data-page-number'));
        
        this.handleDataPagination(pageNumber);
    }

    handleClickPreviousPage() {
        let numberOfPages = parseInt(this.activeContent.find('.tab-pagination-buttons').data('totalPages')) - 1;
        let pageNumber = parseInt($(this.activeContent.find('.pagination-button.active')).attr('data-page-number'));
        $(this.activeContent.find('.pagination-button')).removeClass('active');
        if (numberOfPages >= 5) {

            if (pageNumber > 2 && pageNumber < numberOfPages - 2) {
                this.activeContent.find(".pagination-button").map((i, button) => {
                    $(button).attr('data-page-number', parseInt($(button).attr('data-page-number')) - 1)
                    $(button).text(parseInt($(button).text()) - 1)

                })
            } 
        } 

        $(this.activeContent.find('.pagination-button[data-page-number="' + (parseInt(pageNumber) - 1) + '"]')).addClass('active');

        pageNumber = parseInt($(this.activeContent.find('.pagination-button.active')).attr('data-page-number'));

        this.handleDataPagination(pageNumber);
    }

    handleDataPagination(pageNumber) {
        let number = pageNumber * this.rowsPerPage;
        let numberOfPages = parseInt(this.activeContent.find('.tab-pagination-buttons').data('totalPages')) - 1;
        $(this.activeContent).find('.tab-content-data').empty();
        this.searchData.filter(data => $(this.activeContent).data('type').replace(/\s/g, '').split(",").includes(data.type)).map((data, i) => {
            if (i >= number && i < number + this.rowsPerPage)
                $(this.activeContent).find('.tab-content-data').append(this.createCard(data));
        })

        if ($(window).scrollTop() > this.tabsContent.offset().top + 20) {
            window.scrollTo({ top: this.anchor.offset().top - 40, behavior: 'smooth' });
        }
        
        if (pageNumber > 0) {
            this.activeContent.find(".previous-button").show();
        } else {
            this.activeContent.find(".previous-button").hide();
        }
        if (pageNumber === numberOfPages) {
            this.activeContent.find(".next-button").hide();
        } else {
            this.activeContent.find(".next-button").show();
        }
        
       
    }

    handleCall() {
        $.ajax({
            context: this,
            type: "POST",
            dataType: "json",
            url: this.requestUrl,
            data: {
                page: this.i,
                url: window.location.pathname.toString()
            },
            success: function (result) {
                this.searchData = result;
                this.init();
            },
            error: function () {

            }
        });
    }

    createCard(data) {
        let dataContent = `
            <div class="bootroom-card-long ${data.picture ? `` : `no-image`}">
                <a href="${data.url}" target='_blank'>
                    ${data.picture ?
                `<div class="bootroom-card-long__image" style="background-image:url(${data.picture})">
                        ${data.video ?
                    `<div class="play-button">
                                <span style="border-right-color: #E1261C"></span>
                             </div>` : ``
                }
                         </div>` : ``
            }

                    <div class="card-content">
                        ${data.mainTag ?
                `<div class="main-tag tag-${data.mainTag.replace(/\s+/g, '').toLowerCase()}">${data.mainTag}</div>` : ``
            }
                        <h4>
                            ${data.title}
                        </h4>
                        ${data.text ?
                `<p>${data.text}</p>` : ``
            }
                        ${data.datetime ?
                `<div class="datetime">${data.datetime}</div>` : ``
            }
                        ${data.duration ?
                `<div class="duration">${data.duration}</div>` : ``
            }
                        ${!data.tags.empty ?
                `<div class="tags">${data.tags.map((tag) => { return `<span>${tag}</span>` }).join('')}</div>` : ``
            }
                    </div>
                </a>
            </div>
            <hr/>
        `
        return dataContent
    }

    createPagination(contentLength) {
        let numberOfPages = Math.ceil(contentLength / this.rowsPerPage);
        let numberOfButtons = 0;
        let buttonElement = [];
        if (numberOfPages <= 4) {
            numberOfButtons = numberOfPages;
        } else {
            numberOfButtons = 5
        }
        for (let i = 0; i < numberOfButtons; i++) {
            buttonElement.push(`<span role="button" data-page-number="${i}" data-inc-number=${i+(-2)} class="pagination-button ${i === 0 ? `active` : ``}" >${i+1}</span >`)
        }
        let paginationElement = `
            <div data-total-pages="${numberOfPages}" class="tab-pagination-buttons">
                <span role="button" class="glyphicon glyphicon-menu-left previous-button" style="display:none"></span>
                ${buttonElement.join(' ')}
                <span role="button" class="glyphicon glyphicon-menu-right next-button"></span>
            </div>
        `
        return paginationElement
    }

    tabScroll() {
        let activeElement = this.activeElement;
        this.tabsWrap.each(function () {
            let monthSelected = $(this).find(activeElement);
            $(this).animate({ scrollLeft: $(this).scrollLeft() + monthSelected.offset().left - ($(this).width() - 40) / 2 + monthSelected.width() / 2 }, 500);

        });
    }
    
    attachIndicator() {
        var pos = this.activeElement.position();
        var left = pos.left + this.tabsContainer.offset().left;
        var moveRight = this.lastLeft > pos.left;
        this.lastLeft = pos.left;
        var right = this.tabsContainer.outerWidth() - pos.left - this.activeElement.outerWidth();

        if (!moveRight) {
            this.indicator.css('right', right);
            this.indicator.addClass('first-right');
            setTimeout(() => {
                this.indicator.css('left', pos.left);
                this.indicator.removeClass('first-right');
                this.indicator.addClass('left');
                this.indicator.css('background-color', this.activeElement.data('tabColor'));
                if (this.indicator.hasClass('right')) this.indicator.removeClass('right');
            }, 120);
        } else {
            left = pos.left;

            this.indicator.css('left', pos.left)
            this.indicator.addClass('first-left')
            this.indicator.css('background-color', this.activeElement.data('tabColor'));

            setTimeout(() => {
                this.indicator.addClass('right');
                this.indicator.removeClass('first-left');
                if (this.indicator.hasClass('left')) this.indicator.removeClass('left');
                this.indicator.css('right', right);
            }, 120);
        };
    }
};



Snappy.Component.BootroomTabsHighlight = class BootroomTabsHighlight extends Snappy.BaseComponent {
    static get tagName() {
        return 'bootroom-tabs-highlight';
    }

    constructor(element) {
        super(element);
        this.lastLeft = 0;
        this.searchData = [];
    }

    setVars() {
        this.tabs = $(this.$element.find('.individual-tab-title'));
        this.activeElement = $(this.$element.find('.individual-tab-title.active'));
        this.indicator = this.$element.find('.highlight');
        this.tabsWrap = this.$element.find('.tabs-bar')
        this.tabsContainer = this.$element.find('.tabs-holder');
        this.indicatorColor = this.activeElement.data('tabColor');
        this.anchor = $(this.$element.find('.bootroom-tabs-anchor'));
        this.tabsContent = $(this.$element.find('.bootroom-tabs-content'));
        this.activeContent = this.$element.find('.individual-tab-content.active');
        this.goToLink = '';

    }

    init() {
        this.tabs.map((i, tab) => {
            if (!$(tab).hasClass("active")) {
                $(tab).find('h3').width($(tab).find('h3').width() + ($(tab).find('h3').width() / 15));
            } else {
                $(tab).find('h3').width($(tab).find('h3').width());
            }
        });

        this.activeContent.fadeIn();
        this.indicator.css("background-color", this.indicatorColor);
        this.attachIndicator();
    }

    setEventListeners() {
        window.addEventListener("resize", this.attachIndicator.bind(this));
        window.addEventListener("DOMContentLoaded", this.tabScroll());
        this.$element.find('.individual-tab-title').on('click', this.handleClickTab.bind(this));
    }

    render() {
        this.setVars();
        this.setEventListeners();

        this.init();
    }


    handleClickTab(e) {
        this.activeElement = $(e.currentTarget);
        this.goToLink = ''

        if ((!$(e.currentTarget).hasClass('disabled')) && (!$(e.currentTarget).hasClass('active'))) {
             this.tabs.removeClass('active');
            if (this.tabsContent.length > 0) {
                this.$element.find('.individual-tab-content').removeClass('active');
                this.$element.find('.individual-tab-content').hide();
                $(e.currentTarget).addClass('active');

                $('.individual-tab-content[data-name="' + e.currentTarget.dataset.name + '"]').addClass('active');
                $('.individual-tab-content[data-name="' + e.currentTarget.dataset.name + '"]').fadeIn();

                this.activeContent = $('.individual-tab-content[data-name="' + e.currentTarget.dataset.name + '"]');
            

                if ($(window).scrollTop() > this.tabsContent.offset().top + 20) {
                    window.scrollTo({ top: this.anchor.offset().top - 40, behavior: 'smooth' });
                }
            }
            
            if (this.activeElement.data('goTo') && this.activeElement.data('goTo').length > 0) {
                this.goToLink = this.activeElement.data('goTo')
            }

            this.attachIndicator();

            this.tabScroll()
            e.preventDefault();
        }
    }

    tabScroll() {
        let activeElement = this.activeElement;
        this.tabsWrap.each(function () {
            let monthSelected = $(this).find(activeElement);
            $(this).animate({ scrollLeft: $(this).scrollLeft() + monthSelected.offset().left - ($(this).width() - 0) / 2 + monthSelected.width() / 2 }, 500);

        });
    }

    attachIndicator() {
        var pos = this.activeElement.position();
        var moveRight = this.lastLeft > pos.left;
        this.lastLeft = pos.left;
        var right = this.tabsContainer.outerWidth() - pos.left - this.activeElement.outerWidth();

        if (!moveRight) {
            this.indicator.css('right', right);
            this.indicator.addClass('first-right');
            setTimeout(() => {
                this.indicator.css('left', pos.left);
                this.indicator.removeClass('first-right');
                this.indicator.addClass('left');
                this.indicator.css('background-color', this.activeElement.data('highlightColor'));
                if (this.indicator.hasClass('right')) this.indicator.removeClass('right');
                if (this.goToLink.length > 0) {
                    setTimeout(() => {
                        window.open(this.goToLink, "_self")
                    }, 500);
                }
            }, 120);
        } else {
            this.indicator.css('left', pos.left)
            this.indicator.addClass('first-left')
            this.indicator.css('background-color', this.activeElement.data('tabColor'));

            setTimeout(() => {
                this.indicator.addClass('right');
                this.indicator.removeClass('first-left');
                if (this.indicator.hasClass('left')) this.indicator.removeClass('left');
                this.indicator.css('right', right);
                if (this.goToLink.length > 0) {
                    setTimeout(() => {
                        window.open(this.goToLink, "_self")
                    }, 500);
                }
            }, 120);
        };
    }
};



// WEBPACK FOOTER //
// ./components/edu-tabs/scripts/_edu-tabs.js